import React from 'react';
import styled from 'styled-components';

//Data Types
type Props = {};
//Styled Components
const StyledMain = styled.main`
	min-height: calc(100vh);
	overflow-x: hidden;
`;
//Component
const Content: React.SFC<Props> = ({ children }) => {
	return <StyledMain id='content'>{children}</StyledMain>;
};

export default Content;
